const LineItem = ({ className= ''}) => {
    return <div className={`line-bottom ${className}`} />
}

export default LineItem
